"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DeviceOptionsCms = void 0;
var DeviceOptionsCms = /** @class */ (function () {
    function DeviceOptionsCms() {
        this.supportTitleLabel = "Do you want to keep your number or get a new one?";
        this.supportTitleBsseLabel = "Here\u2019s your new mobile number(s).";
        this.supportTitleBsseWithoutCtnLabel = "We\u2019ll send you an email with your new mobile number(s).";
        this.titleLabel = 'Mobile number';
        this.noPortMessage = "Need to transfer a number from another carrier?\n    You'll need to change to the \"Full-service pickup\" option above.";
        this.transferNumberLabel = "Let's finish your request to transfer your number.";
    }
    return DeviceOptionsCms;
}());
exports.DeviceOptionsCms = DeviceOptionsCms;
//# sourceMappingURL=DeviceOptions.cms.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@idse/checkout-ui/components/panels/DeviceOptionsPanel/DeviceOptions/DeviceOptions.cms.js
// module id = 2004
// module chunks = 8